
import { formatDateTimeRelative } from "@/lib/utils";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Zap, Users, Wallet, Percent } from "lucide-react";

interface EnergiaStatsProps {
  resumo: {
    totalClientes: number;
    totalConsumo: number;
    percentualUsoGerador: number;
    totalEconomia: number;
    ultimaAtualizacao: Date;
  }
}

const EnergiaStats = ({ resumo }: EnergiaStatsProps) => {
  return (
    <>
      <div className="mb-6 flex flex-col md:flex-row justify-between items-start md:items-center">
        <div>
          <p className="text-gray-600 mt-1 text-opacity-70">
            Última atualização: {formatDateTimeRelative(resumo.ultimaAtualizacao)}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6">
        <Card className="bg-gradient-to-br from-blue-50 to-white border-blue-100">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium flex items-center">
              <Zap className="h-4 w-4 mr-2 text-blue-500" />
              Consumo Total
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-xl md:text-2xl font-bold text-blue-700">{resumo.totalConsumo.toFixed(0)} kWh</div>
            <p className="text-xs text-muted-foreground">Consumo mensal</p>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-purple-50 to-white border-purple-100">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium flex items-center">
              <Users className="h-4 w-4 mr-2 text-purple-500" />
              Clientes
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-xl md:text-2xl font-bold text-purple-700">{resumo.totalClientes}</div>
            <p className="text-xs text-muted-foreground">Clientes ativos</p>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-green-50 to-white border-green-100">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium flex items-center">
              <Wallet className="h-4 w-4 mr-2 text-green-500" />
              Economia
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-xl md:text-2xl font-bold text-green-700">R$ {resumo.totalEconomia.toFixed(2)}</div>
            <p className="text-xs text-muted-foreground">Economia mensal</p>
          </CardContent>
        </Card>
        
        <Card className="bg-gradient-to-br from-amber-50 to-white border-amber-100">
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium flex items-center">
              <Percent className="h-4 w-4 mr-2 text-amber-500" />
              Capacidade
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-xl md:text-2xl font-bold text-amber-700">{resumo.percentualUsoGerador.toFixed(1)}%</div>
            <p className="text-xs text-muted-foreground">Utilização da capacidade</p>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default EnergiaStats;
